$(document).ready(function(){
//-----------------header js start---------------------//
    $(function() {
    $('.header .header__inline-menu .list-menu--inline details').on('mouseover', function() {
      $(this).attr('open', true);
    }).on('mouseout', function() {
      $(this).attr('open', false);

    });
  });

//-----------------header js end----------------------//
//-------------------- image with accordian js start-----------//

    // Initially show the .inner element and add the active class
    // $('.inner').show();
    $('.toggle_btn').addClass('active');

    $('.itg-up-arrow-icon').click(function(){
        $('.inner').slideToggle();
        $('.toggle_btn').toggleClass('active');
    });

//-------------------- image with accordian js end-----------//

//----------------- cart page js start--------------- //

     // $('#Recent').hide();

    $(".c-product__img a").each(function() {
        var href = $(this).attr('href'); // Get the href attribute for each link
      if (!href) { 
         $('.show_recently_view').css('display', 'none');
        $(this).closest('#Recent').hide();
    }else{
        $('.show_recently_view').css('display', 'block');
        $(this).closest('#Recent').show();
    }
    })

// ----------------cart page js  end------------------- //
//----------------- accordian redirection js start ---------------//

    $('.image-with-text__text h2').each(function() {
        var h2Text = $(this).text().trim(); 
        var idValue = h2Text.replace(/\s+/g, '-').replace(/[^\w-]/g, '').toLowerCase(); 
        $(this).attr('id', idValue); 
    });

    $('.itg-text-content-ltr h2').each(function() {
        var h2Text = $(this).text().trim(); 
        var idValue = h2Text.replace(/\s+/g, '-').replace(/[^\w-]/g, '').toLowerCase(); 
        $(this).attr('id', idValue); 
    });

//----------------- accordian redirection js end---------------//
//-----------------collection page video popup js start--------------//


  $('.video-wrapper').on('click', function() {
    $('#video-popup').fadeIn();
     $('.blank').fadeIn(1000);
 });
  $('.close-video-btn, #video-popup').on('click', function() {
    $('#video-popup').fadeOut();
     $('.blank').fadeOut(1000);
    $('#video-frame').attr('src', '');

  });
  $('.video-popup-content').on('click', function(e) {
    e.stopPropagation();
  });

//-----------------collection page video popup js end--------------//
//-------------------------fancy box js start---------------------//
 
    $(".open").on("click", function(e) {
        e.preventDefault(); 

        
        var items = $("[data-fancybox='gallery']").map(function() {
            return {
                src: $(this).attr('href'), 
                opts: {
                    caption: $(this).find('img').attr('alt'), 
                    thumb: $(this).find('img').attr('src') 
                }
            };
        }).get();

       
        $.fancybox.open(items, {
            loop: true 
        });
    });

 
//---------------------------fancy box js end--------------------//
//-----Why Do You Need A Guest Book For A Funeral slider(Guide for appreciative responses section) js start--------//
 $('.image_slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll:1 ,
    autoplay:true,
    prevArrow:'<svg class="svg_custom prev" width="25" height="25" viewBox="0 0 27 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.718 39.1691C21.328 35.5391 18.028 31.8192 14.628 28.1992C9.58797 22.8192 9.56797 22.8392 14.878 17.4092C18.348 13.8592 21.828 10.2992 25.268 6.70915C26.508 5.41915 26.978 3.85915 26.148 2.14915C25.428 0.669151 24.138 0.0191507 22.508 0.00915068C21.088 -0.0808493 19.918 0.499151 18.948 1.47915C13.218 7.22915 7.46797 12.9592 1.79797 18.7692C-0.732027 21.3592 -0.522027 23.9792 1.98797 26.6292C7.56797 32.5292 13.048 38.5092 18.548 44.4892C20.568 46.6792 22.878 47.9392 25.408 45.6292C27.828 43.4092 26.608 41.1991 24.718 39.1691Z" fill="#E5E6E6"/></svg>',
    nextArrow:'<svg class="svg_custom next" width="25" height="25" viewBox="0 0 28 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.97343 39.8566C6.36343 36.2266 9.66343 32.5067 13.0634 28.8867C18.1034 23.5067 18.1234 23.5267 12.8134 18.0967C9.34343 14.5467 5.86343 10.9867 2.42343 7.39665C1.18343 6.10665 0.713434 4.54665 1.54343 2.83665C2.26343 1.35665 3.55343 0.706651 5.18343 0.696651C6.60343 0.606651 7.77343 1.18665 8.74343 2.16665C14.4734 7.91665 20.2234 13.6467 25.8934 19.4567C28.4234 22.0467 28.2134 24.6667 25.7034 27.3167C20.1234 33.2167 14.6434 39.1967 9.14343 45.1767C7.12343 47.3667 4.81343 48.6267 2.28343 46.3167C-0.136566 44.0967 1.08343 41.8866 2.97343 39.8566Z" fill="#E5E6E6"/></svg>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  });
//-----Why Do You Need A Guest Book For A Funeral slider(Guide for appreciative responses section) js end--------//
//-------- slick slider js start--------//
   $('.custom_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll:1 ,
    // autoplay:true,
    prevArrow:'<svg class="svg_custom prev" width="25" height="25" viewBox="0 0 27 47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.718 39.1691C21.328 35.5391 18.028 31.8192 14.628 28.1992C9.58797 22.8192 9.56797 22.8392 14.878 17.4092C18.348 13.8592 21.828 10.2992 25.268 6.70915C26.508 5.41915 26.978 3.85915 26.148 2.14915C25.428 0.669151 24.138 0.0191507 22.508 0.00915068C21.088 -0.0808493 19.918 0.499151 18.948 1.47915C13.218 7.22915 7.46797 12.9592 1.79797 18.7692C-0.732027 21.3592 -0.522027 23.9792 1.98797 26.6292C7.56797 32.5292 13.048 38.5092 18.548 44.4892C20.568 46.6792 22.878 47.9392 25.408 45.6292C27.828 43.4092 26.608 41.1991 24.718 39.1691Z" fill="#E5E6E6"/></svg>',
    nextArrow:'<svg class="svg_custom next" width="25" height="25" viewBox="0 0 28 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.97343 39.8566C6.36343 36.2266 9.66343 32.5067 13.0634 28.8867C18.1034 23.5067 18.1234 23.5267 12.8134 18.0967C9.34343 14.5467 5.86343 10.9867 2.42343 7.39665C1.18343 6.10665 0.713434 4.54665 1.54343 2.83665C2.26343 1.35665 3.55343 0.706651 5.18343 0.696651C6.60343 0.606651 7.77343 1.18665 8.74343 2.16665C14.4734 7.91665 20.2234 13.6467 25.8934 19.4567C28.4234 22.0467 28.2134 24.6667 25.7034 27.3167C20.1234 33.2167 14.6434 39.1967 9.14343 45.1767C7.12343 47.3667 4.81343 48.6267 2.28343 46.3167C-0.136566 44.0967 1.08343 41.8866 2.97343 39.8566Z" fill="#E5E6E6"/></svg>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  });
//-------- slick slider js end--------//
//-----------------wishlist section js start---------------//


  $(".wishlist-icon , .video-section__poster").click(function(){
  $(".video-section__poster").css("display" , "none");
    $(".wishlist-icon").css("display" , "none");
    $(".wishlistvedio iframe").click();

  });
 


 window.onload = function(){

  	var canvas = document.getElementById("snow");
  	var ctx = canvas.getContext("2d");
  	var W = window.innerWidth;
  	var H = window.innerHeight;
  	canvas.width = W;
  	canvas.height = H;
  	var mp = 30;
  	var particles = [];

  	for(var i = 0; i < mp; i++) {
  		particles.push({
  			x: Math.random()*W,
  			y: Math.random()*H,
  			r: Math.random()*2+0.5, // Reduced the size of the snowflakes
  			d: Math.random()*mp
  		})
  	}

  	// draw the snowflakes
  	function draw() {
  		ctx.clearRect(0, 0, W, H);
  		ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
  		ctx.beginPath();
  		for(var i = 0; i < mp; i++) {
  			var p = particles[i];
  			ctx.moveTo(p.x, p.y);
  			ctx.arc(p.x, p.y, p.r, 0, Math.PI*2, true);
  		}
  		ctx.fill();
  		update();
  	}

  	var angle = 0;

  	// move the snowflakes
  	function update() {
  		angle += 0.002; // Reduced the angle increment for slower movement
  		for(var i = 0; i < mp; i++) {
  			var p = particles[i];
  			p.y += Math.cos(angle + p.d) + 0.2 + p.r/3; // Slowed down the y movement
  			p.x += Math.sin(angle) * 0.5; // Slowed down the x movement
  			if(p.x > W+5 || p.x < -5 || p.y > H) {
  				if(i%3 > 0) {
  					particles[i] = {x: Math.random()*W, y: -10, r: p.r, d: p.d};
  				} else {
  					if(Math.sin(angle) > 0) {
  						particles[i] = {x: -5, y: Math.random()*H, r: p.r, d: p.d};
  					} else {
  						particles[i] = {x: W+5, y: Math.random()*H, r: p.r, d: p.d};
  					}
  				}
  			}
  		}
  	}

  	// animation loop
  	setInterval(draw, 33);
  }

//-----------------wishlist section js end---------------//
//-------------home page banner js start------------------//
  $(window).on('load', function() {
  // $('.custom-image-banner .video-section__poster').show();
    setTimeout(function() {
          $('.custom-image-banner .video-section__poster').hide();
      }, 1000);
  });

//-------------home page banner js end------------------//
//--------------product page variant selection js start--------------//

$(window).on('load', function() {
  if ($('.WithImprint').prev('input').is(':checked')) {
    $('.additional-info').show();
  } else {
    $('.additional-info').hide();
  }
});

$('input').on('change', function() {
 if ($('.WithImprint').prev('input').is(':checked')) {
    $('.additional-info').show();
  } else {
    $('.additional-info').hide();
  }
});


  

//--------------product page variant selection js end--------------//
 });